"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TERMS_OF_USE_URL = exports.TELEHEALTH_INFORMED_CONSENT_URL = exports.SUPPORT_URL = exports.PRIVACY_POLICY_URL = exports.PATIENT_AUTHORIZATION_URL = exports.NOTICE_OF_PRIVACY_PRACTICES_URL = exports.MARKETING_SITE_URL = exports.INTAKE_TAB_PATH = exports.FINANCIAL_EXPECTATIONS_POLICIES_URL = exports.FAQ_URL = exports.EMERGENCY_CONTACT_URL = exports.CONSENT_TO_MEDICAL_CARE_URL = exports.CONSENT_FOR_TEXTS_AND_EMAILS_URL = exports.CONSENT_FOR_RATINGS_AND_REVIEWS_URL = exports.CARE_PRESCRIPTIONS = exports.CARE_APPOINTMENTS = void 0;
var CARE_PATH = '/care';
var CARE_APPOINTMENTS = "".concat(CARE_PATH, "/appointments");
exports.CARE_APPOINTMENTS = CARE_APPOINTMENTS;
var CARE_PRESCRIPTIONS = "".concat(CARE_PATH, "/prescriptions");
exports.CARE_PRESCRIPTIONS = CARE_PRESCRIPTIONS;
var INTAKE_TAB_PATH = 'intake-form';
exports.INTAKE_TAB_PATH = INTAKE_TAB_PATH;
var MARKETING_SITE_URL = process.env.REACT_APP_MARKETING_SITE_URL;
exports.MARKETING_SITE_URL = MARKETING_SITE_URL;
var CONSENT_FOR_RATINGS_AND_REVIEWS_URL = "".concat(MARKETING_SITE_URL, "/publicity-release");
exports.CONSENT_FOR_RATINGS_AND_REVIEWS_URL = CONSENT_FOR_RATINGS_AND_REVIEWS_URL;
var FINANCIAL_EXPECTATIONS_POLICIES_URL = "".concat(MARKETING_SITE_URL, "/consent-for-recurring-credit-or-debit-card-payments");
exports.FINANCIAL_EXPECTATIONS_POLICIES_URL = FINANCIAL_EXPECTATIONS_POLICIES_URL;
var PATIENT_AUTHORIZATION_URL = "".concat(MARKETING_SITE_URL, "/patient-authorization");
exports.PATIENT_AUTHORIZATION_URL = PATIENT_AUTHORIZATION_URL;
var PRIVACY_POLICY_URL = "".concat(MARKETING_SITE_URL, "/privacy-policy");
exports.PRIVACY_POLICY_URL = PRIVACY_POLICY_URL;
var CONSENT_TO_MEDICAL_CARE_URL = "".concat(MARKETING_SITE_URL, "/consent-to-medical-care-agreement-and-related-disclosures");
exports.CONSENT_TO_MEDICAL_CARE_URL = CONSENT_TO_MEDICAL_CARE_URL;
var TELEHEALTH_INFORMED_CONSENT_URL = "".concat(MARKETING_SITE_URL, "/informed-consent-to-telehealth-visits");
exports.TELEHEALTH_INFORMED_CONSENT_URL = TELEHEALTH_INFORMED_CONSENT_URL;
var NOTICE_OF_PRIVACY_PRACTICES_URL = "".concat(MARKETING_SITE_URL, "/notice-of-privacy-practices");
exports.NOTICE_OF_PRIVACY_PRACTICES_URL = NOTICE_OF_PRIVACY_PRACTICES_URL;
var TERMS_OF_USE_URL = "".concat(MARKETING_SITE_URL, "/terms-of-use");
// TODO: confirm we are removing this
exports.TERMS_OF_USE_URL = TERMS_OF_USE_URL;
var CONSENT_FOR_TEXTS_AND_EMAILS_URL = "".concat(MARKETING_SITE_URL, "/consent-to-receive-texts-and-emails-from-monument-inc");
exports.CONSENT_FOR_TEXTS_AND_EMAILS_URL = CONSENT_FOR_TEXTS_AND_EMAILS_URL;
var FAQ_URL = 'https://support.joinmonument.com/hc/en-us';
exports.FAQ_URL = FAQ_URL;
var EMERGENCY_CONTACT_URL = "".concat(FAQ_URL, "/articles/360040717114-Are-you-experiencing-a-crisis-or-emergency");
exports.EMERGENCY_CONTACT_URL = EMERGENCY_CONTACT_URL;
var SUPPORT_URL = "".concat(FAQ_URL, "/requests/new");
exports.SUPPORT_URL = SUPPORT_URL;